import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

const STATUSES = ["pending", "approved", "hidden"];

export default function AdminReviews() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const load = () => api.get("/admin/reviews").then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => { await api.put(`/admin/reviews/${id}/status`, { status }); toast.success(`Set ${status}`); load(); };
  const del = async (id) => { if (!confirm("Delete review?")) return; await api.delete(`/admin/reviews/${id}`); load(); };

  const filtered = filter === "all" ? items : items.filter((i) => i.status === filter);

  return (
    <div data-testid="admin-reviews" className="space-y-8">
      <header className="flex items-end justify-between flex-col lg:flex-row gap-4">
        <div><div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Customer Reviews</div><h1 className="editorial-h1 text-5xl mt-2">{items.length} voices.</h1></div>
        <div className="flex flex-wrap gap-2">{["all", ...STATUSES].map((s) => (<button key={s} onClick={() => setFilter(s)} data-testid={`rv-filter-${s}`} className={`btn-pill text-xs ${filter === s ? "btn-dark" : "btn-ghost border border-brand-line"}`}>{s}</button>))}</div>
      </header>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((r) => (
          <div key={r.id} className="card-elevated p-5" data-testid={`adm-rv-${r.id}`}>
            <div className="flex items-center justify-between"><div className="font-medium">{r.customer_name}</div><div className="text-brand-yellow">{"★".repeat(r.rating || 5)}</div></div>
            {r.title && <div className="font-display text-xl mt-2">{r.title}</div>}
            <p className="mt-2 text-sm text-brand-charcoal/70">{r.body}</p>
            {r.product_name && <div className="mt-2 text-[10px] uppercase tracking-[0.22em] text-brand-charcoal/50">{r.product_name}</div>}
            <div className="mt-3 flex flex-wrap gap-1">
              <span className="text-[10px] uppercase tracking-[0.18em] border border-brand-line rounded-full px-2 py-0.5">{r.status}</span>
              {STATUSES.map((s) => (<button key={s} onClick={() => setStatus(r.id, s)} className="btn-pill btn-ghost text-[10px] border border-brand-line">{s}</button>))}
              <button onClick={() => del(r.id)} className="btn-pill btn-ghost text-[10px] text-brand-red border border-brand-line">delete</button>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <div className="text-brand-charcoal/60">Nothing here.</div>}
      </div>
    </div>
  );
}
